// extracted by mini-css-extract-plugin
export var attachButton = "_cn-8";
export var sendButton = "_cn-2";
export var sendDisabled = "_cn-4";
export var sendEnabled = "_cn-3";
export var sendIcon = "_cn-6";
export var sendIconDisabled = "_cn-7";
export var sendStreaming = "_cn-5";
export var textarea = "_cn-1";
export var wrapper = "_cn-0";